export function isValidProductBarcode(value: string | null | undefined): boolean {
  const code = value?.trim() ?? '';
  if (!code) { return true; }
  if (!/^(?:\d{8}|\d{12}|\d{13})$/.test(code)) { return false; }
  const sum = [...code].reduce((total, digit, index) =>
    total + Number(digit) * ((code.length - 1 - index) % 2 === 0 ? 1 : 3), 0);
  return sum % 10 === 0;
}
